import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { ExportStateService } from 'src/app/service/export-state.service';
import { environment } from "../../../environments/environment";
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

	navlinks;
	rolesArray = [];
	userName: string = "";
	userInfo;
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;
	constructor(private readonly constants: Constants, private readonly exportStateService: ExportStateService, private readonly versionCheckService: VersionCheckService) { }

	ngOnInit(): void {
		this.subscription = this.exportStateService.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				this.navlinks = this.constants.navLinkItems;
    			this.userName = localStorage.getItem('name');
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if(roles?.length) {
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
		this.versionCheckService.initVersionCheck();
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace(environment.LIOS_HOME_URL);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
